import React, { useState } from 'react';
import EmployeeTable from '../component/EmployeeTable'; // Table un-commented
import EmployeeDrawer from '../component/EmployeeDrawer';
import { useEmployees } from '../hooks/useEmployees';
import { Search, RefreshCw } from 'lucide-react';

export default function EmployeeDirectoryPage() {
  const {
    employees,
    meta,
    loading,
    error,
    searchQuery,
    setSearchQuery,
    currentPage,
    setCurrentPage,
    setPerPage,
    refetch,
  } = useEmployees();

  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleRowClick = (employee) => {
    setSelectedEmployee(employee);
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedEmployee(null);
  };

  return (
    <div className="w-full h-full p-6 md:p-8 flex flex-col gap-6 bg-slate-50/60 overflow-y-auto">
      
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h2 className="text-xl font-extrabold text-slate-900 tracking-tight">Employee Directory</h2>
          <p className="text-xs text-slate-500 mt-0.5">Manage organization employees and profiles.</p>
        </div>

        <div className="flex items-center gap-3">
          <button 
            onClick={refetch}
            className="flex items-center gap-2 px-3.5 py-2 bg-white border border-slate-200 rounded-xl text-xs font-bold text-slate-700 hover:bg-slate-50 transition shadow-2xs cursor-pointer"
          >
            <RefreshCw className="w-3.5 h-3.5" />
            Refresh
          </button>
        </div>
      </div>

      {/* Search Bar */}
      <div className="bg-white p-4 rounded-2xl border border-slate-200 shadow-xs flex items-center justify-between gap-4">
        <div className="relative w-full sm:w-96">
          <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <input
            type="text"
            placeholder="Search by name, employee code, or email..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-10 pr-4 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs text-slate-800 placeholder:text-slate-400 focus:outline-none focus:border-blue-500 transition"
          />
        </div>

        {meta && (
          <div className="text-xs font-semibold text-slate-500">
            Total: <span className="text-slate-900 font-bold">{meta.total}</span>
          </div>
        )}
      </div>

      {/* Error Alert */}
      {error && (
        <div className="p-4 bg-rose-50 border border-rose-200 text-rose-600 rounded-2xl text-xs font-semibold">
          Error: {error}
        </div>
      )}

      {/* Employee Table Component */}
      <EmployeeTable 
        employees={employees} 
        meta={meta}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setPerPage={setPerPage}
        onRowClick={handleRowClick} 
      />

      {/* Slide-over Drawer */}
      <EmployeeDrawer 
        isOpen={isDrawerOpen} 
        onClose={handleCloseDrawer} 
        employee={selectedEmployee} 
      />

    </div>
  );
}